enum INDICES_PARAMS {
    VOTER_PARAM = 'address',
    REPUTATION_SHARES_PARAM = 'balance',
    BANZHAF_INDEX_PARAM = 'banzhafIndex',
}

export { INDICES_PARAMS };
